<div [formGroup]="form">
  <h2 class="text-center"> {{editMode ? 'Edit Follow Up Counselling Assessment' : 'Add Follow Up Counselling Assessment' }}</h2>
  <div class="row">


<!--    <mat-form-field appearance="outline" class="col-md-3 col-sm-6">-->
<!--      <mat-label>Centres</mat-label>-->
<!--      <ng-container *ngIf="!editMode; else Centres">-->
<!--        <mat-select (selectionChange)="onCentreSelect($event)">-->
<!--          <mat-option value="All">All Centres</mat-option>-->
<!--          <mat-option *ngFor="let c of (_centres$ | async)" [value]="c">{{ c.centreName }}</mat-option>-->
<!--        </mat-select>-->
<!--      </ng-container>-->
<!--      <ng-template #Centres>-->
<!--        <input matInput [value]="this.form.controls.centreName?.value" readonly>-->
<!--      </ng-template>-->
<!--    </mat-form-field>-->


    <app-searchable-select class="col-md-4"
                           [options]="_centres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>


<!--    <mat-form-field appearance="outline" class="col-md-3 col-sm-6">-->
<!--      <mat-label>Select Child</mat-label>-->
<!--      <ng-container *ngIf="!editMode; else Child">-->
<!--        <mat-select (selectionChange)="searchChild($event)" [disabled]="editMode">-->
<!--          <mat-option *ngFor="let c of filteredChildren" [value]="c">{{ c.firstName }} {{ c.lastName }}</mat-option>-->
<!--        </mat-select>-->
<!--      </ng-container>-->
<!--      <ng-template #Child>-->
<!--        <input matInput [value]="this.form.controls.childName?.value" readonly>-->
<!--      </ng-template>-->
<!--    </mat-form-field>-->


    <mat-form-field appearance="outline" class="col-md-3 col-sm-6">
      <mat-label>Select Child</mat-label>

      <ng-container *ngIf="!editMode; else Child">
        <mat-select
          [formControl]="childSelectControl"
          (selectionChange)="searchChild($event)"
          (opened)="onChildDropdownOpen()"
          [disabled]="editMode">

          <!-- SEARCH INPUT -->
          <mat-option class="no-select-option"
                      (click)="$event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search child..."
                [formControl]="childSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <!-- FILTERED CHILD RESULT -->
          <mat-option *ngFor="let child of filteredChildData"
                      [value]="child">
            {{ child.firstName }} {{ child.lastName }}
          </mat-option>

        </mat-select>
      </ng-container>

      <ng-template #Child>
        <input matInput [value]="this.form.controls.childName?.value" readonly>
      </ng-template>
    </mat-form-field>




    <mat-form-field appearance="outline" class="col-md-3 col-sm-6">
      <mat-label>Assessment No.</mat-label>
      <mat-select formControlName="sessionType">
        <mat-option *ngFor="let a of assessmentTypes" [value]="a">{{ a }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3 col-sm-6">
      <mat-label>Session Date</mat-label>
      <input matInput [matDatepicker]="apicker" formControlName="dateOfAssessment" [max]="maxDate">
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="apicker"></mat-datepicker-toggle>
      <mat-datepicker #apicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="div" *ngIf="editMode">
<!--    <p> Centre Name : {{ this.form.controls.centreName?.value }}</p>-->
<!--    <p> Child Name : {{ this.form.controls.childName?.value }}</p>-->
    <p *ngIf="this.form.controls.sessionDate!=null"> Session Date
      : {{ this.form.controls.sessionDate?.value|date:'dd/MM/yyyy' }}</p>

  </div>


  <div class="mt-2">
    <!--            <prettyjson [obj]="form.value"></prettyjson>-->
    <div>
      <h2 class="rounded rounded-2 text-center">Questions</h2>
      <div formArrayName="questions">
        <ng-container *ngFor=" let f of formArray.controls;let i=index">
          <div [formArrayName]="i">
            <mat-card class=" m-2">
              <h3>({{ i + 1 }}) {{ questionList[i].question }}</h3>
              <div>
                <mat-radio-group color="primary" aria-labelledby="example-radio-group-label"
                                 class="example-radio-group" formControlName="ans">
                  <mat-radio-button class="example-radio-button ms-2 me-2 " *ngFor="let ans of answers"
                                    [value]="ans">
                    {{ ans }}
                  </mat-radio-button>&nbsp;&nbsp;&nbsp;
                </mat-radio-group>
              </div>
              <div class="m-1">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label>Remark</mat-label>
                  <input matInput formControlName="remark">
                </mat-form-field>
              </div>
            </mat-card>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button mat-raised-button color="warn" (click)="mDialogRef.close()">Cancel</button>&nbsp;&nbsp;
      <button mat-raised-button color="primary" [disabled]="disableSubmit" type="submit" (click)="Submit()">{{editMode ?'Update':'Submit'}}</button>
    </div>
  </div>

</div>
